export default "__VITE_ASSET__Br5H8aSI__"